import { Clipboard } from '@capacitor/clipboard'

export async function writeToClipboard(text: string): Promise<boolean> {
  try {
    await Clipboard.write({ string: text })
    return true
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Failed to write to clipboard', e)
    return false
  }
}
